// src/mocks/handlers/budgets.handlers.js
import * as data from '../data/budgets.demo';

// Handles all /budget-quotes routes
export const handle = async (config) => {
    if (config.method === 'post') return data.budgetCreated;
    if (/\/budget-quotes\/\d+/.test(config.url)) return data.budgetDetail;
    return data.budgetList;
};
